module.exports = __webpack_public_path__ + "static/stella_zhang_comp-476337addd7df79b76bd9a157f063da5.jpg";